import { render, staticRenderFns } from "./enableMfa.vue?vue&type=template&id=cc2dfdb2&"
import script from "./enableMfa.vue?vue&type=script&lang=js&"
export * from "./enableMfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports